import React, { useEffect } from "react";
import { Toast } from "devextreme-react/toast";
import dxDataGrid from "devextreme/ui/data_grid";

export interface IToastProps {
	gridDataId: any;
  currentLabels: any;
}

const AEAToast: React.FC<IToastProps> = (props) => {
  const [parentGrid, setParentGrid] = React.useState(null);
	const [toastConfig, setToastConfig] = React.useState({
		isVisible: false,
		type: null,
		message: "",
	});

  const onCellClick = (data: any) => {
    let typeId = (data?.data?.PProaTipoContrapartida) ? data?.data?.PProaTipoContrapartida[0] : null;
    if(["IdContrapartida"].includes(data.column.dataField) && typeId === 5){
      setToastConfig({
        isVisible: true,
        type: 'info',
        message: props.currentLabels.get("customValueMessage")
      });
    }
  }

	const onHidingToast = () => {
		setToastConfig({
			...toastConfig,
			isVisible: false,
		});
	};

	useEffect(() => {
		if (props.gridDataId) {
			const container = document.getElementById(
				props.gridDataId
			) as HTMLElement;
			const instance = dxDataGrid.getInstance(container) as dxDataGrid;
			setParentGrid(instance);
		}
	}, [props]);

  useEffect(() => {
    if(parentGrid) parentGrid.option("onCellClick", onCellClick);
	}, [parentGrid]);

	return (
		<div>
			<Toast
				visible={toastConfig.isVisible}
				message={toastConfig.message}
				type={toastConfig.type}
				onHiding={onHidingToast}
				displayTime={10000}
			/>
		</div>
	);
};

export default AEAToast;
